import React from 'react';
import Type from 'prop-types';
import { Typography, Checkbox, Radio } from '@mui/material';
import styles from './CustomerOption.module.css';

const CustomerOption = (props) => {
  const { compact, liProps, option, state } = props;

  const SecondaryAction = state?.multiple === false ? Radio : Checkbox;

  return (
    <li {...liProps}>
      <div className={styles.optionContent}>
        <div className={styles.optionText}>
          <Typography component="div" variant="body1">
            {compact ? `${option.id} ${option.name}` : option.name}
          </Typography>
          {!compact && (
            <Typography component="div" variant="body2" color="textSecondary">
              {`(${option.id}) ${option.clgroup}`}
            </Typography>
          )}
          {option.inn && (
            <Typography component="div" variant="body2" color="textSecondary">
              {`ИНН ${option.inn}`}
            </Typography>
          )}
        </div>
      </div>
      <div className={styles.secondaryAction}>
        <SecondaryAction color="primary" edge="end" checked={state?.selected || false} />
      </div>
    </li>
  );
};

CustomerOption.propTypes = {
  compact: Type.bool,
  liProps: Type.object,
  option: Type.shape({
    id: Type.string.isRequired,
    name: Type.string.isRequired,
    inn: Type.string,
    clgroup: Type.string,
  }).isRequired,
  state: Type.shape({
    selected: Type.bool,
    multiple: Type.bool,
  }),
};

CustomerOption.defaultProps = {
  compact: false,
  multiple: false,
};

export default CustomerOption;
